export enum Paths {
  Main = '/',
  Basket = '/wishlist',
  TermsOfUse = '/account/terms-of-use',
  Activities = '/activities',
  ActivityDetails = '/activities/:id',
  Merchandise = '/merchandise',
  MerchandiseDetails = '/merchandise/:id',
  Accommodations = '/accommodations',
  AccommodationDetails = '/accommodations/:id',
  AccommodationBookingSuccess = '/booking/accommodation/success',
  AirTransport = 'transport/air',
  AirTransportBookingSuccess = '/booking/transport/air/success',
  TrainTransport = '/transport/trainbus',
  TrainTransportDetails = '/transport/trainbus/details',
  SignIn = '/account/login',
  SignUp = '/account/register',
  ForgotPassword = '/account/forgot-password',
  AccountMain = '/account',
  AccountDetails = '/account/details',
  Invoices = '/account/invoices',
  TravelPlanner = '/account/travel-planner',
  TravelHistory = '/account/travel-history',
  Checkout = '/checkout',
  AffiliateProductTypeRedirect = '/affiliate-link/:id/product-type-redirect',
  AffiliateActivityDetails = '/affiliate-link/activity/:id/',
  AffiliateMerchandiseDetails = '/affiliate-link/merchandise/:id/',
  AffiliateAccommodationDetails = '/affiliate-link/accommodation/:id/',
  AffiliateTransportListAir = '/affiliate-link/transport-search/air',
  AffiliateTransportListTrainbus = '/affiliate-link/transport-search/trainbus',
  AffiliateTransportDetailsTrainbus = '/affiliate-link/transport-details/trainbus',
  AffiliateCheckout = '/affiliate-link/checkout'
}
